<template>
	<div>
		<monitor :developer="true" :system="false"></monitor>
	</div>
</template>

<script>

import Monitor from '../monitor/List.vue'

export default {
	components: {
		Monitor
	}
}

</script>